<template>
  <v-card class="ma-0" :maxHeight="height" :minHeight="minHeight">
    <v-card-title class="secondary white--text py-0" @click="updateData"> Задачи по чек-листу ({{ pager.count }}) </v-card-title>
    <v-divider />
    <v-card-text class="mt-0 pa-1 pt-0">
      <div v-if="loading" class="loading-block">
        <div class="loader"></div>
      </div>
      <div v-if="data.length > 0">
        <v-simple-table fixed-header dense :height="height - 36" ref="tableGoods">
          <template v-slot:default>
            <thead class="main-table-header">
              <tr>
                <th class="text-left px-1"></th>
                <th class="text-left px-1">Заголовок</th>
                <th class="text-left px-1">Объект</th>
                <th class="text-left px-1">Дэдлайн</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(el, i) in data" :key="i" @click="$emit('click', el)" style="cursor: pointer">
                <td class="text-left px-1">
                  <a-view-table-chip
                    :value="el.is_important"
                    :model="{
                      hideText: true,
                      showText: el.id,
                      options: $store.getters['config/get'].models.tasks.optionsIsImportant,
                    }"
                  />
                </td>
                <td class="text-left px-1">
                  <v-chip x-small v-if="el.status == 200" color="error" class="px-1"> new </v-chip>
                  <a-view-table-taskname :value="el.name" :values="el" />
                </td>
                <td class="text-left px-1">
                  <a-view-table-string :value="el.object_name" />
                </td>

                <td class="text-left px-1">
                  <a-view-table-date :value="el.date_end" />
                </td>
              </tr>
            </tbody> </template
        ></v-simple-table>
      </div>
      <div v-else>Список пуст</div>
    </v-card-text>
  </v-card>
</template>

<script>
import { getIndex } from "@/components/mixings";
export default {
  mixins: [getIndex],
  components: {},
  props: {
    height: { type: Number, default: 0 },
  },
  data() {
    return {
      contentHeight: 10,
      loading: false,
      data: [],
      pager: {},
      api: "/mechti/buying",
      limit: 50,
    };
  },
  created() {
    this.init();
  },
  mounted() {
    document.addEventListener("scroll", this.onScroll, true);
  },
  destroyed() {
    document.removeEventListener("scroll", this.onScroll, true);
  },
  computed: {
    minHeight() {
      let h = this.height;
      if (this.$vuetify.breakpoint.name == "xs" && this.data.length == 0) {
        h = 0;
      }
      return h;
    },

    defaults() {
      const status = this.$store.getters["config/get"].models.tasks.statuses
        .filter(el => {
          return !["ready", "cancel"].includes(el?.status);
        })
        .map(s => {
          return s.value;
        });
      return {
        sort: [
          { key: "buying.status", condition: "=", value: 200, order: "DESC" },
          { key: "date_start", order: "ASC" },
        ],
        filters: {
          user_id: this.$root.profile.role == 40 ? this.$root.profile.id : undefined,
          //is_show_main: 1,
          status,
          date_start: { condition: ">", value: "2024-01-01" },
        },
      };
    },
  },
  methods: {
    maxPage: function () {
      const count = this.pager.count?.count_id || this.pager.count;
      let res = this.pager.limit == 0 ? 0 : Math.ceil(count / this.pager.limit);
      return res;
    },
    onScroll(e) {
      let el = this.$refs.tableGoods;
      let offset = 200;
      if (el) {
        el = el && el.$el.querySelector(".v-data-table__wrapper");
        if (e.target == el) {
          if (el.scrollHeight - el.offsetHeight <= el.scrollTop + offset) {
            this.onScrollEnd();
          }
        }
      }
    },
    onScrollEnd(e) {
      if (!this.loading && this.maxPage() > this.pager.page) {
        this.pager.page++;
        this.fetchData(true);
      }
    },
    getFilters() {
      if (this.defaults.sessionFilters) {
        this.filters = this.defaults.sessionFilters;
      } else if (this.defaults.filters) {
        this.filters = Object.assign({}, this.defaults.filters);
      } else this.filters = {};
    },
    getName(el) {
      return (el.status == 200 ? "[Новая]" : "") + el.name;
    },
    init() {
      this.data = [];
      this.getFilters();
      if (this.defaults.sort) this.sort = this.defaults.sort;
      else this.sort = [{ key: "id", order: "ASC" }];
      //      if (this.limit !== 0)

      this.reloadData();
    },
    reloadData() {
      this.updateData();
    },
    refresh() {
      this.data = [];

      this.updateData();
    },
    updateData() {
      this.pager = {};
      this.pager.limit = this.limit;
      if (this.useQuery && this.$route.query[this.urlPrefix]) {
        let params = JSON.parse(this.$route.query[this.urlPrefix]);
        if (params.sort) {
          this.sort = params.sort;
        }
        if (params.filters) {
          this.filters = params.filters;
        }
      }
      this.pager.page = 0;
      this.fetchData();
    },
  },
};
</script>
